module.exports = __webpack_public_path__ + "img/onyx_pool_villa.dc15f4e8.jpg";